import {MMQueryOptions} from 'lionheartland';


export class SODeleteBacklog {

  constructor(
    public uid: string,
    public predicate: string = null,
    public queryOptions: MMQueryOptions = new MMQueryOptions(),
  ) {
  }
}
